module.exports = __webpack_public_path__ + "static/media/tree_PeersGroup.c9aecdb5.png";